import { V2Tooltip } from "@stacklet/ui";

import { SearchBar } from "app/components/SearchBar";
import { useHasScopePermission } from "app/hooks";

import { CreateNonSsoUser } from "../users/user-list/components/actions/CreateNonSsoUser";

export function UsersActionBar() {
  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    <div className="mb-6 flex items-center justify-between">
      <SearchBar
        className="w-[25rem]"
        onSearch={undefined}
        title="Search users"
      />
      <V2Tooltip
        title={
          hasSystemEditPermission
            ? ""
            : "You need system edit permissions to create a user"
        }
        asChild
      >
        <span>
          <CreateNonSsoUser />
        </span>
      </V2Tooltip>
    </div>
  );
}
